import { Popover, PopoverBody } from 'reactstrap'
import { IoIosClose } from 'react-icons/io'
import s from './PriorityPopover.scss'

const PriorityPopover = ({
  isOpen,
  currentId,
  triggerPriorityPopover,
  priorities,
  addNewPriority,
  changePriority
}) => (
  <Popover
    placement="right"
    isOpen={isOpen}
    target={`priority-${currentId}`}
    toggle={triggerPriorityPopover}
  >
    <PopoverBody>
      <h2>
        <IoIosClose className={s.closeModal} onClick={() => triggerPriorityPopover(currentId)} />
      </h2>
      <ul className={s.priorityList}>
        {priorities.map(priority => {
          return (
            <li key={priority.name} onClick={() => changePriority(currentId, priority)}>
              <i className={s.priorityRepresenation} style={{ background: priority.color }} />
              <span>{priority.name}</span>
            </li>
          )
        })}
        <li onClick={() => changePriority(currentId, { name: '' })}>
          <span>None</span>
        </li>
      </ul>
      <div className={s.addNewWrapper}>
        <span onClick={addNewPriority}>+ Add New</span>
      </div>
    </PopoverBody>
  </Popover>
)

export default PriorityPopover
